import { ActionFunction, redirect } from 'react-router-dom';
import { client } from '~/api/client';
import { mutateData } from '~/api/data/request';
import { submitMutation } from '~/api/data/responses';
import {
  CreateVoiceAgentDocument,
  CreateVoiceAgentMutation,
  CreateVoiceAgentMutationVariables,
  UpdateVoiceAgentDocument,
  UpdateVoiceAgentMutation,
  UpdateVoiceAgentMutationVariables
} from '~/api/graphql';

export const createVoiceAgent = (variables: CreateVoiceAgentMutationVariables) =>
  mutateData<CreateVoiceAgentMutation, CreateVoiceAgentMutationVariables>(client, {
    mutation: CreateVoiceAgentDocument,
    variables
  });

export const updateVoiceAgent = (variables: UpdateVoiceAgentMutationVariables) =>
  mutateData<UpdateVoiceAgentMutation, UpdateVoiceAgentMutationVariables>(client, {
    mutation: UpdateVoiceAgentDocument,
    variables
  });

export const submitCreateVoiceAgent: ActionFunction = async ({ request }) =>
  submitMutation(createVoiceAgent({ input: await request.json() }), async (data) =>
    redirect(`/app/settings/voice/${data?.createVoiceAgent?.id}`)
  );

export const submitUpdateVoiceAgent: ActionFunction = async ({ params, request }) => {
  const { input, transferDirectoryChanges, idempotencyKey } = await request.json();
  return submitMutation(
    updateVoiceAgent({ id: params.id || '', input, transferDirectoryChanges, idempotencyKey })
  );
};
